export default function GreenTick() {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2311_7683)">
        <path
          d="M6 0.499969C2.688 0.499969 0 3.18797 0 6.49997C0 9.81197 2.688 12.5 6 12.5C9.312 12.5 12 9.81197 12 6.49997C12 3.18797 9.312 0.499969 6 0.499969ZM4.8 9.49997L1.8 6.49997L2.646 5.65397L4.8 7.80197L9.354 3.24797L10.2 4.09997L4.8 9.49997Z"
          fill="#0BEC9F"
        />
      </g>
      <defs>
        <clipPath id="clip0_2311_7683">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
